import React, { useEffect, useState } from "react";
import { alpha, useTheme } from "@mui/material/styles";
import makeStyles from "utils/makeStyles";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "utils/Box";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Avatar from "@mui/material/Avatar";
import WarningIcon from "@mui/icons-material/Warning";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { connect, useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useNavigate } from 'react-router-dom';
import { withRouter } from 'utils/withRouter';
import {
  setAlertData,
  updateCurrentUserAction,
  setAppTheme,
  setAppLogo,
  toggleFullScreen,
  toggleAsOperator,
  enableTaxesPerVM,
  getSettings,
  setSettingsData,
  setCompanySettingsData,
} from "../../../redux/actions";
import { auth, SaUserService } from "../../../services";
import { CrudDialog } from "..";
import { handleServerErrors } from "../../../helpers";
import { currencyOptions, saveCurrencyToLocalStorage } from "utils/helpers";
import useNotifications from "./useNotifications";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "dayjs";
import { ReactComponent as UserIco } from "../../../assets/appIcons/header-icons/account.svg?react";
import { ReactComponent as BellIco } from "../../../assets/appIcons/header-icons/notification.svg?react";
import { ReactComponent as HideIco } from "../../../assets/appIcons/header-icons/collapse.svg?react";
import { authStorage } from "../../../services/AuthStorage";

const useStyles = makeStyles((theme) => {
  return {
    appbar: {
      boxShadow: "none",
      background: "#fff",
    },
    toolbar: {
      background: "#fff",
      borderBottom: "1px solid #b1b1b1",
      padding: 0,
      paddingRight: 20,
    },
    title: {
      flexGrow: 1,
      color: "#000",
    },
    navbarContent: {
      height: 64,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "absolute",
      right: 4,
      top: 3,
      zIndex: 2,
    },
    navLogoWrapper: {
      height: "100%",
      width: "10.5em",
      paddingLeft: 10,
      display: "flex",
      alignItems: "center",
    },
    defaultLogo: {
      width: "100%",
    },
    email: {
      color: "#8a8a8a",
      fontSize: 17,
    },
    logout: {
      color: "#8a8a8a",
      fontSize: 16,
      "&:hover": {
        color: "#464545",
      },
    },
    tab: {
      color: "#676b6f",
      fontWeight: "bold",
      fontSize: 14,
    },
    logo: {
      marginRight: "15px",
      marginLeft: "15px",
      height: 40,
    },
    boxStyle: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    raiseIssue: {
      display: "inline-block",
      padding: "6px 12px",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      borderRadius: "999px",
      fontWeight: 500,
      fontSize: "14px",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.5),
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
      },
    },
  };
});

const Navbar = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [operaterOpen, setOperaterOpen] = React.useState(false);
  const [profileModal, setProfileModal] = React.useState(false);

  const [preferencesModal, setPreferencesModal] = React.useState(false);
  const [passwordModal, setPasswordModal] = React.useState(false);
  const [settingsModal, setSettingsModal] = React.useState(false);
  const [visible, setVisible] = React.useState(!props.fullscreen);

  const [showChatbotPosition, setShowChatbotPosition] = useState(false);
  const [showCoordinates, setShowCoordinates] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { alertData, newNotification, notificationToggle } = useNotifications(
    props.currentUser.type
  );
  const [notificationPopper, setNotificationPopper] = React.useState(false);
  const anchorRef = React.useRef(null);
  const anchorOpRef = React.useRef(null);
  const preferenceData = useSelector(
    (state) => state.initialLoadReducer.preferenceData
  );
  const settingsData = useSelector(
    (state) => state.initialLoadReducer.settingsData
  );
  const companySettingsData = useSelector(
    (state) => state.initialLoadReducer.companySettingsData
  );

  const notificationButtonRef = React.useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showCrudDialogSubmitLoader, setShowCrudDialogSubmitLoader] =
    useState(false);

  useEffect(() => {
    if (props.fullscreen) {
      setVisible(false);
    } else {
      setTimeout(() => {
        setVisible(true);
      }, 500);
    }
  }, [props.fullscreen]);

  const handleRaiseIssue = () => {
    window.open("https://issues.dmvi.cloud/", "_blank");
  };

  const fields = [
    {
      key: "username",
      columnName: "Username",
      label: "Username",
      type: "text",
      required: false,
      disabled: true,
      visible: true,
    },
    [
      {
        key: "first_name",
        columnName: "First Name",
        label: "First Name",
        type: "text",
        required: true,
        visible: true,
      },
      {
        key: "last_name",
        columnName: "Last Name",
        label: "Last Name",
        type: "text",
        required: true,
        visible: true,
      },
    ],
    {
      key: "email",
      columnName: "Email",
      label: "Email",
      type: "email",
      required: true,
      visible: true,
      disabled: true,
    },
    { key: "type", columnName: "Role", value: "CA", type: "text" },
    {
      key: "password",
      label: "Password",
      type: "password",
      required: false,
      visible: false,
    },
    {
      key: "video_url",
      columnName: "Meeting URL",
      label: "Meeting URL",
      type: "text",
      visible: props.currentUser.type === "EM" ? true : false,
    },
  ];

  const preferencesFields = [
    [
      {
        key: "primary_color",
        columnName: "Primary color",
        label: "Primary color",
        value: props.theme.palette.primary.main,
        type: "color",
        visible: true,
      },
      {
        key: "secondary_color",
        columnName: "Secondary color",
        label: "Secondary color",
        value: props.theme.palette.primary.dark,
        type: "color",
        visible: true,
      },
    ],
    {
      key: "logo",
      width: 100,
      label: "Logo",
      type: "file",
      hint: "Suggested file types: png, jpg, jpeg, gif",
      form: true,
      visible: true,
    },
  ];
  const settingsFields = [
    [
      {
        key: "transaction_endpoint",
        label: "Transaction Endpoint",
        type: "text",
        visible: true,
      },
      {
        key: "userinfo_endpoint",
        label: "User Data Endpoint",
        type: "text",
        visible: true,
      },
    ],
    [
      {
        key: "auth_endpoint",
        label: "Auth Endpoint",
        type: "text",
        visible: true,
      },
      {
        key: "operator_api_username",
        label: "Operator Cloud Username",
        type: "text",
        visible: true,
      },
    ],
    [
      {
        key: "operator_api_password",
        label: "Operator Cloud Password",
        type: "text",
        visible: true,
      },
      {
        key: "thanks_background",
        label: "Thank You Background URL",
        type: "text",
        visible: true,
        validations: [
          {
            type: "custom",
            message: "Please enter a valid URL e.g https://kanboards.com",
            value: (value) =>
              /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
                value
              ),
          },
        ],
      },
    ],
    [
      {
        key: "web_store_url",
        label: "Webstore base URL",
        type: "text",
        visible: true,
        validations: [
          {
            type: "custom",
            message: "Please enter a valid URL e.g https://kanboards.com",
            value: (value) =>
              /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
                value
              ),
          },
        ],
      },
      {
        key: "payment_url",
        label: "Payment base URL",
        type: "text",
        visible: true,
        validations: [
          {
            type: "custom",
            message: "Please enter a valid URL e.g https://kanboards.com",
            value: (value) =>
              /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
                value
              ),
          },
        ],
      },
    ],
    {
      key: "currency",
      columnName: "Currency",
      label: "Currency",
      visible: true,
      show: true,
      type: "autocomplete",
      options: currencyOptions.map((value) => ({
        label:
          value.abbr === "NONE"
            ? value.name
            : `${value.name} (${value.abbr}) - ${value.symbol}`,
        value: value.abbr,
      })),
      freeSolo: false,
      disableClearable: true,
    },
    {
      key: "sender_email",
      label: "Sender Email",
      type: "email",
      visible: true,
    },
    {
      key: "order_reservation_hours",
      label: "Order Reservation Hours",
      type: "number",
      visible: true,
      isInteger: true,
    },
    {
      key: "scanner_support",
      label: "Enable Age Verification Method",
      type: "checkbox",
      visible: true,
    },
    {
      key: "enable_screensaver_locker",
      label: "Enable Screensaver Locker",
      type: "checkbox",
      visible: true,
    },
    {
      key: "enable_taxes_per_vm",
      label: "Enable Taxes per Vending Machine",
      type: "checkbox",
      visible: true,
    },
    ...(companySettingsData.is_chatbot_enabled_for_op
      ? [
          {
            key: "is_chatbot_enabled_on_vm",
            label: "Enable Chatbot",
            type: "checkbox",
            visible: true,
          },
        ]
      : []),
    {
      key: "chatbot_position",
      columnName: "Chatbot Position",
      label: "Chatbot Position",
      required: true,
      visible: showChatbotPosition,
      show: showChatbotPosition,
      type: "autocomplete",
      options: [
        {
          label: "Top Left",
          value: "TopLeft",
        },
        {
          label: "Top Right",
          value: "TopRight",
        },
        {
          label: "Bottom Left",
          value: "BottomLeft",
        },
        {
          label: "Bottom Right",
          value: "BottomRight",
        },
        {
          label: "Custom",
          value: "Custom",
        },
      ],
      freeSolo: false,
      disableClearable: true,
    },
    [
      {
        key: "x_axis_percentage",
        label: "X-Axis Percentage",
        required: true,
        type: "text",
        visible: showCoordinates,
        validations: [
          {
            type: "custom",
            message: "Please enter a value between 0 and 100",
            value: (value) => value >= 0 && value <= 100,
          },
        ],
      },
      {
        key: "y_axis_percentage",
        label: "Y-Axis Percentage",
        required: true,
        type: "text",
        visible: showCoordinates,
        validations: [
          {
            type: "custom",
            message: "Please enter a value between 0 and 100",
            value: (value) => value >= 0 && value <= 100,
          },
        ],
      },
    ],
  ];
  const passwordFields = [
    {
      key: "old_password",
      label: "Current Password",
      type: "password",
      password: true,
      required: true,
      visible: true,
      validations: [
        {
          type: "required",
          value: true,
          message: "Current password is required.",
        },
      ],
    },
    {
      key: "new_password",
      label: "New Password",
      type: "password",
      password: true,
      required: true,
      visible: true,
      validations: [
        {
          type: "minLength",
          value: 9,
          message:
            "Must be 9 characters long and should contain a combination of a special character, an uppercase, lowercase letter and number(s)",
        },
        {
          type: "custom",
          value: (value, values) => {
            if (
              !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9}$/.test(
                values.new_password
              )
            ) {
              return false;
            } else {
              return true;
            }
          },
          message:
            "Must be 9 characters long and should contain a combination of a special character, an uppercase, lowercase letter and number(s)",
        },
      ],
    },
    {
      key: "confirm_password",
      label: "Confirm Password",
      type: "password",
      password: true,
      required: true,
      visible: true,
      validations: [
        {
          type: "required",
          value: true,
          message: "Confirm password is required.",
        },
        {
          type: "custom",
          value: (value, values) => {
            if (values.confirm_password !== values.new_password) {
              return false;
            } else {
              return true;
            }
          },
          message: "New password & confirm password must be same.",
        },
      ],
    },
  ];

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  //**  REDIRECT SUB_OP TO MAIN OP **//
  const handleOperaterToggle = () => {
    authStorage.set("current_user", JSON.parse(authStorage.get("parent_user")));
    dispatch(
      updateCurrentUserAction(JSON.parse(authStorage.get("parent_user")))
    );
    dispatch(toggleAsOperator(false));
    navigate("/dashboard");
    setTimeout(() => {
      window.location.reload(false);
    }, 500);
  };

  // Component Will Unmount //
  useEffect(() => {
    if (props.loginAsOperator) {
      dispatch(toggleAsOperator(true));
    }
    // returned function will be called on component unmount
    return () => {
      dispatch(toggleAsOperator(false));
    };
  }, []);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    const ele = document.getElementById("lhc_container_v2");
    if (ele) {
      ele.style.display = "none";
    }

    setOpen(false);
  };

  const updateStatus = async (e) => {
    try {
      const callData = {
        is_taking_calls: false,
      };
      const data = await window.axiosIns.post(
        "/call_request/is_available",
        callData
      );
    } catch (err) {
    } finally {
      props.navigate("/login");
      auth.remove_user();
      dispatch(toggleAsOperator(false));
      dispatch(updateCurrentUserAction({}));
      dispatch(setAlertData([]));
      handleClose(e);
    }
  };

  const handleNotificationClose = (event) => {
    if (
      notificationButtonRef.current &&
      notificationButtonRef.current.contains(event.target)
    ) {
      return;
    }

    setNotificationPopper(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const prevOperaterOpen = React.useRef(operaterOpen);

  useEffect(() => {
    if (prevOperaterOpen.current === true && operaterOpen === false) {
      anchorOpRef.current.focus();
    }

    prevOperaterOpen.current = operaterOpen;
  }, [operaterOpen]);

  useEffect(() => {
    if (
      companySettingsData.is_chatbot_enabled_for_op &&
      companySettingsData.is_chatbot_enabled_on_vm
    ) {
      setShowChatbotPosition(true);
      if (companySettingsData.chatbot_position === "Custom") {
        setShowCoordinates(true);
      } else {
        setShowCoordinates(false);
      }
    }
  }, [companySettingsData]);

  const editPreferences = (values, error) => {
    const fd = new FormData();
    values.logo && values.logo.type && fd.append("logo", values.logo);
    fd.append("primary_color", values.primary_color);
    fd.append("user", props.currentUser.user_id);
    fd.append("secondary_color", values.secondary_color);
    // fd.append("device_label", values.device_label);

    setShowCrudDialogSubmitLoader(true);
    if (preferenceData?.id) {
      window.axiosIns
        .put(`/preference/${preferenceData.id}`, fd)
        .then((res) => {
          dispatch(
            setAppTheme({
              primaryColor: res.data.primary_color,
              secondaryColor: res.data.secondary_color,
              customTheme: true,
            })
          );
          dispatch(setAppLogo({ appLogo: res.data.logo }));
          setPreferencesModal(false);
          enqueueSnackbar("Preferences Edit successfully.");
          setShowCrudDialogSubmitLoader(false);
        })
        .catch((err) => {
          setShowCrudDialogSubmitLoader(false);
          if (err.response.data.detail) {
            enqueueSnackbar(err.response.data.detail);
          } else {
            handleServerErrors(
              err,
              enqueueSnackbar,
              "Could not Edit Preferences. Try again."
            );
          }
        });
    } else {
      window.axiosIns
        .post(`/preference`, fd)
        .then((res) => {
          dispatch(
            setAppTheme({
              primaryColor: res.data.primary_color,
              secondaryColor: res.data.secondary_color,
              customTheme: true,
            })
          );
          dispatch(setAppLogo({ appLogo: res.data.logo }));
          setPreferencesModal(false);
          enqueueSnackbar("Preferences Added successfully.");
          setShowCrudDialogSubmitLoader(false);
        })
        .catch((err) => {
          setShowCrudDialogSubmitLoader(false);
          if (err.response.data.detail) {
            enqueueSnackbar(err.response.data.detail);
          } else {
            handleServerErrors(
              err,
              enqueueSnackbar,
              "Could not add Preferences. Try again."
            );
          }
        });
    }
  };

  const editUser = (values, error) => {
    if (error) {
      return;
    }
    setShowCrudDialogSubmitLoader(true);
    SaUserService.update(props.currentUser.user_id, { ...values })
      .then((response) => {
        if (response.status === "success") {
          const user = { ...props.currentUser };
          user.first_name = response.data.first_name;
          user.last_name = response.data.last_name;
          user.email = response.data.email;
          dispatch(updateCurrentUserAction(user));
          setProfileModal(false);
          setPasswordModal(false);
          enqueueSnackbar("Profile updated successfully");
        } else {
          enqueueSnackbar("Could not update user. Try again.");
        }
        setShowCrudDialogSubmitLoader(false);
      })
      .catch((error) => {
        setShowCrudDialogSubmitLoader(false);
        handleServerErrors(
          error,
          enqueueSnackbar,
          "Could not update user. Try again."
        );
      });
  };

  const getHumanizeTime = (timestamp) => {
    const x = moment(timestamp);
    const y = moment();

    return moment.duration(x.diff(y)).humanize(true);
  };

  const updateSettings = async (values, error) => {
    let orderReservationHours = null;
    if (
      values.order_reservation_hours !== undefined &&
      values.order_reservation_hours !== ""
    ) {
      orderReservationHours = values.order_reservation_hours;
      if (
        values.order_reservation_hours < 1 ||
        values.order_reservation_hours > 999
      ) {
        enqueueSnackbar("Order Reservation Hours should be between 1 to 999.");
        return;
      }
    }
    values.scanner_support = values.scanner_support ? true : false;
    const user = props.currentUser;

    const data = {
      operator_api_username: values.operator_api_username,
      operator_api_password: values.operator_api_password,
      thanks_background: values.thanks_background,
      transaction_endpoint: values.transaction_endpoint,
      userinfo_endpoint: values.userinfo_endpoint,
      auth_endpoint: values.auth_endpoint,
      company: user.company.company_id,
      scanner_support: values.scanner_support,
      currency: values.currency,
      enable_screensaver_locker: values?.enable_screensaver_locker,
      enable_taxes_per_vm: values?.enable_taxes_per_vm,
      order_reservation_hours: orderReservationHours,
      is_chatbot_enabled_on_vm: values.is_chatbot_enabled_on_vm,
      chatbot_position: values.chatbot_position,
      x_axis_percentage: values.x_axis_percentage,
      y_axis_percentage: values.y_axis_percentage,
    };
    localStorage.setItem("scanner_state", values.scanner_support);
    if (error) return;

    try {
      setShowCrudDialogSubmitLoader(true);
      const objLength = Object.keys(companySettingsData).length;
      if (objLength > 0) {
        const [connectedDevicesRes, statsRes] = await Promise.all([
          window.axiosIns.put(
            `company/${user.company.company_id}/setting`,
            values
          ),
          window.axiosIns.put(
            `/company_settings/${companySettingsData.id}`,
            data
          ),
        ]);
        dispatch(setCompanySettingsData(statsRes?.data));
      } else {
        const [connectedDevicesRes, statsRes] = await Promise.all([
          window.axiosIns.put(
            `company/${user.company.company_id}/setting`,
            values
          ),
          window.axiosIns.post("/company_settings", data),
        ]);
        dispatch(setCompanySettingsData(statsRes?.data));
      }

      enqueueSnackbar("Settings updated successfully");
      dispatch(enableTaxesPerVM(values?.enable_taxes_per_vm || false));

      const currencyAbbr = values.currency || "USD";
      saveCurrencyToLocalStorage(currencyAbbr);

      dispatch(setSettingsData(values));
      setSettingsModal(false);
      setShowCrudDialogSubmitLoader(false);
    } catch (err) {
      setShowCrudDialogSubmitLoader(false);
      console.log(err);
      handleServerErrors(
        err,
        enqueueSnackbar,
        "Could not update settings. Try again"
      );
    }
  };

  const typesLabels = {
    SA: "Super Admin",
    CA: "Customer Admin",
    EU: "End User",
    SU: "Support User",
    DE: "DevOps Admin",
    FO: "Floor Operator",
    OP: "Operator",
    GA: "Group Admin",
    EM: "Employee",
    DU: "Operator",
  };

  const updatePassword = (values, error) => {
    if (error) {
      return;
    }
    setShowCrudDialogSubmitLoader(true);
    SaUserService.updatePassword(values)
      .then((response) => {
        if (response.status === "success") {
          enqueueSnackbar("Password changed successfully");
          setProfileModal(false);
          setPasswordModal(false);
        } else {
          enqueueSnackbar("Could not update password. Try again");
        }
        setShowCrudDialogSubmitLoader(false);
      })
      .catch((error) => {
        setShowCrudDialogSubmitLoader(false);
        try {
          if (error && error.response && error.response.status === 400) {
            enqueueSnackbar(error.response.data.message);
            //enqueueSnackbar(Object.values(error.response.data.message)[0][0]);
          } else if (error && error.response && error.response.status === 401) {
            enqueueSnackbar("Current password is incorrect");
          }
        } catch (error) {
          handleServerErrors(
            error,
            enqueueSnackbar,
            "Could not update password. Try again"
          );
        }
      });
  };

  return (
    <>
      <div
        style={{ display: visible ? "block" : "block" }}
        className={classes.root}
      >
        <div className={classes.navbarContent}></div>
        <div className={classes.navbarContent} style={{ zIndex: 99 }}>
          <div className="d-flex align-items-center">
            <div
              ref={notificationButtonRef}
              aria-haspopup="true"
              onClick={handleRaiseIssue}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "8px",
                padding: "6px 24px",
                cursor: "pointer",
                backgroundColor: "#f7f8fa",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                transition: "background-color 0.2s ease",
                height: 76,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e0e0e0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f7f8fa";
              }}
            >
              <span
                style={{
                  fontWeight: 500,
                  fontSize: "14px",
                  position: "relative",
                  fontWeight: "bold",
                  color: theme.palette.primary.main,
                }}
              >
                Raise Issue
              </span>
            </div>
            {props.loginAsOperator && (
              <IconButton
                style={{ outline: "none" }}
                ref={anchorOpRef}
                aria-controls={operaterOpen ? "menu-list-grow-op" : undefined}
                aria-haspopup="true"
                onClick={handleOperaterToggle}
                size="large">
                <PeopleAltIcon style={{ width: 25, height: 25 }} />
              </IconButton>
            )}
            {props.currentUser?.apps.filter(
              (data) =>
                data?.app_slug === "event-logs" && data?.is_installed === true
            ).length >= 1 && (
              <div
                ref={notificationButtonRef}
                aria-haspopup="true"
                onClick={() => {
                  setNotificationPopper((prevState) => !prevState);
                  notificationToggle();
                }}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "8px",
                  padding: "6px 24px",
                  cursor: "pointer",
                  backgroundColor: "#f7f8fa",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  transition: "background-color 0.2s ease",
                  height: 76,
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#e0e0e0";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#f7f8fa";
                }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "14px",
                    position: "relative",
                    fontWeight: "bold",
                    color: theme.palette.primary.main,
                  }}
                >
                  Alerts
                  {newNotification && (
                    <span
                      style={{
                        position: "absolute",
                        top: -4,
                        right: -8,
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: "red",
                      }}
                    ></span>
                  )}
                </span>
              </div>
            )}

            <div
              ref={anchorRef}
              aria-controls={open ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                padding: "6px 12px 6px 18px",
                cursor: "pointer",
                backgroundColor: "#f7f8fa",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                transition: "background-color 0.2s ease",
                height: 76,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e0e0e0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f7f8fa";
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: theme.palette.primary.main,
                }}
              >
                {typesLabels[props.currentUser.type]}&nbsp;
                <ExpandMoreIcon />
              </div>
            </div>

            <Popper
              open={open}
              anchorEl={anchorRef.current}
              style={{ marginTop: 15, width: 150 }}
              className={classes.menuPopper}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "right top" : "right bottom",
                  }}
                >
                  <Paper elevation={3}>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        style={{ padding: 0 }}
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem
                          style={{
                            fontSize: 14,
                            minHeight: 40,
                            backgroundColor: "#ededed",
                          }}
                        >
                          {props.currentUser.username.toUpperCase()}
                        </MenuItem>
                        {props.currentUser.id || props.currentUser.user_id ? (
                          <MenuItem
                            style={{ fontSize: 14, minHeight: 40 }}
                            onClick={(e) => {
                              setProfileModal(true);
                              handleClose(e);
                            }}
                          >
                            Edit Profile
                          </MenuItem>
                        ) : null}

                        {props.currentUser.id || props.currentUser.user_id
                          ? props.currentUser.type !== "SA" && (
                              <MenuItem
                                style={{ fontSize: 14, minHeight: 40 }}
                                onClick={(e) => {
                                  setPreferencesModal(true);
                                  handleClose(e);
                                }}
                              >
                                Preferences
                              </MenuItem>
                            )
                          : null}

                        <MenuItem
                          style={{ fontSize: 14, minHeight: 40 }}
                          onClick={(e) => {
                            setPasswordModal(true);
                            handleClose(e);
                          }}
                        >
                          Change Password
                        </MenuItem>
                        {(props.currentUser.type == "OP" ||
                          props.currentUser.type == "DU") && (
                          <MenuItem
                            style={{ fontSize: 14, minHeight: 40 }}
                            onClick={(e) => {
                              setSettingsModal(true);
                              handleClose(e);
                            }}
                          >
                            Settings
                          </MenuItem>
                        )}
                        <MenuItem
                          style={{ fontSize: 14, minHeight: 40 }}
                          onClick={(e) => {
                            if (props.currentUser.type === "EM") {
                              updateStatus(e);
                            } else {
                              props.navigate("/login");
                              auth.remove_user();
                              dispatch(toggleAsOperator(false));
                              dispatch(updateCurrentUserAction({}));
                              dispatch(setAlertData([]));
                              handleClose(e);
                            }
                          }}
                        >
                          Logout
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </div>
        <CrudDialog
          title="Edit Profile"
          okText="Save Changes"
          description="Please fill details below to update profile."
          fields={[...fields].map((x) => {
            const obj = x;
            if (obj.key === "username") {
              obj.disabled = true;
            }
            return obj;
          })}
          values={props.currentUser}
          onSubmit={editUser}
          open={profileModal}
          onClose={() => setProfileModal(false)}
          showSubmitActionLoader={showCrudDialogSubmitLoader}
        />
        <CrudDialog
          title="Preferences"
          okText="Save"
          description="Please fill details below to update preferences."
          fields={preferencesFields}
          values={props.currentUser}
          onSubmit={editPreferences}
          open={preferencesModal}
          onClose={() => setPreferencesModal(false)}
          showSubmitActionLoader={showCrudDialogSubmitLoader}
        />

        <CrudDialog
          title="Change Password"
          okText="Save Changes"
          description="Please fill details below to change password."
          fields={passwordFields}
          onSubmit={updatePassword}
          open={passwordModal}
          onClose={() => setPasswordModal(false)}
          showSubmitActionLoader={showCrudDialogSubmitLoader}
        />

        <CrudDialog
          title="Settings"
          okText="Save"
          description="Please fill details below to update settings."
          fields={settingsFields}
          onFieldChange={(field, value, values) => {
            if (field.key === "is_chatbot_enabled_on_vm" && value === true) {
              setShowChatbotPosition(true);
              if (values.chatbot_position === "Custom") {
                setShowCoordinates(true);
              }
            } else if (
              field.key === "is_chatbot_enabled_on_vm" &&
              value === false
            ) {
              setShowChatbotPosition(false);
              setShowCoordinates(false);
            }
            if (
              field.key === "chatbot_position" &&
              value === "Custom" &&
              showChatbotPosition
            ) {
              setShowCoordinates(true);
            } else if (field.key === "chatbot_position") {
              setShowCoordinates(false);
            }
          }}
          onSubmit={updateSettings}
          values={{ ...settingsData, ...companySettingsData }}
          open={settingsModal}
          onClose={() => setSettingsModal(false)}
          showSubmitActionLoader={showCrudDialogSubmitLoader}
        />
        <Popper
          open={notificationPopper}
          anchorEl={notificationButtonRef.current}
          style={{ marginTop: 15, width: 350, zIndex: 999999 }}
          className={classes.menuPopper}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "right top" : "right bottom",
              }}
            >
              <Paper elevation={3}>
                <ClickAwayListener onClickAway={handleNotificationClose}>
                  <MenuList
                    style={{ padding: 0 }}
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    {!!alertData.length && (
                      <>
                        <MenuItem
                          style={{ fontSize: 14, minHeight: 40 }}
                          onClick={(e) => {
                            handleNotificationClose(e);
                          }}
                        >
                          <Typography variant="subtitle1">
                            Notifications
                          </Typography>
                        </MenuItem>
                        <Divider />
                      </>
                    )}
                    {alertData.length ? (
                      <List style={{ maxHeight: 380, overflow: "scroll" }}>
                        {alertData.map((value) => (
                          <ListItem key={value?.id}>
                            <ListItemAvatar>
                              <Avatar>
                                <WarningIcon />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={`${value?.message} ${
                                value?.serial_no ? `(${value?.serial_no})` : ""
                              }`}
                              secondary={getHumanizeTime(
                                value?.received_timestamp
                              )}
                            />
                          </ListItem>
                        ))}
                      </List>
                    ) : (
                      <MenuItem
                        style={{
                          fontSize: 14,
                          minHeight: 40,
                          textAlign: "center",
                        }}
                        onClick={(e) => {
                          handleNotificationClose(e);
                        }}
                      >
                        <Box className={classes.boxStyle}>
                          <Typography variant="subtitle1">No Alerts</Typography>
                        </Box>
                      </MenuItem>
                    )}

                    {!!alertData.length && (
                      <>
                        <Divider />
                        <MenuItem
                          style={{
                            fontSize: 14,
                            minHeight: 40,
                            textAlign: "center",
                          }}
                          onClick={(e) => {
                            handleNotificationClose(e);
                            // props.navigate('/vending-machines?logs=true')
                            props.navigate("/event-logs");
                          }}
                        >
                          <Box className={classes.boxStyle}>
                            <Typography variant="subtitle1">See All</Typography>
                          </Box>
                        </MenuItem>
                      </>
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.userReducer.current_user,
    fullscreen: state.routeReducer.fullscreen,
    theme: state.userReducer.theme,
    loginAsOperator: state.userReducer.loginAsOperator,
  };
};

export default connect(mapStateToProps)(withRouter(Navbar));
